'use client'
import { Grid } from '@achieve/ascend'
import { CardEmployeeStory } from 'components/Cards/CardEmployeeStory'
import { Typography } from 'components/Contentful'
import styles from './EmployeeStoriesGrid.module.scss'
import { _get } from 'utils/shared'
import { useViewportSmallerThan } from 'utils/viewport'
import { BREAKPOINTS } from 'constants/viewport'
import { PaperCarousel } from 'components/Carousels/PaperCarousel'
import Section from 'components/Section'
import classNames from 'classnames'

function EmployeeStoriesGrid({ content }) {
  const isMobile = useViewportSmallerThan(BREAKPOINTS.xl)
  const title = _get(content, 'fields.sectionContents[0]')
  const grid = _get(content, 'fields.sectionContents[1].fields.gridItemsCollection.items')
  let carouselItems = grid?.map((card, id) => {
    return {
      metadata: {},
      sys: { id: `item${id}` },

      fieldName: `employeeCarousel-${id}`,
      uiComponent: 'Card',
      cardImage: card.image,
      cardText: {
        json: {
          content: [card.eyebrow, card.title, card.text, card.link.linkText.json],
        },
      },
      cardLink: card.link,
    }
  })

  const theme = { name: 'Employee Section Theme', fieldName: 'theme', theme: ['white'] }

  return (
    <Section className={styles['grid-section']} data-testid="EmployeeStoriesGrid_section">
      {!isMobile ? (
        <>
          <Typography
            content={title?.fields?.textContent?.json}
            variant={'displayLg'}
            component="h2"
            className={styles['grid-title']}
            fontWeight="bold"
            data-testid={`employee-grid-title`}
          />
          <Grid
            spacing={'32px'}
            className={classNames(styles['employee-card-grid'], 'gap-16')}
            data-testid="employee-grid-container"
          >
            {grid?.map((card, idx) => {
              return (
                <Grid xl={4} key={idx} data-testid={`employee-grid-item-${idx}`}>
                  <CardEmployeeStory data-testid="employee-grid-card" key={idx} content={card} />
                </Grid>
              )
            })}
          </Grid>
        </>
      ) : (
        <>
          <PaperCarousel
            data-testid="employee-carousel"
            title={title}
            carouselItems={carouselItems}
            theme={theme}
            idPrefix="home"
          />
        </>
      )}
    </Section>
  )
}

export { EmployeeStoriesGrid }
export default EmployeeStoriesGrid
